<div class="seg-profile-widget">
  @if (widgetTitle) {
    <div class="widget-title-header">
      <h4 class="widget-title">{{ titleMeta.isCustom ? widgetTitle : (widgetTitle | translate) }}{{ titleMeta.tailPrefix }}{{ titleMeta.tailKey | translate }}{{ titleMeta.tail }}</h4>
    </div>
  }
  @if (widgetTitle) {
    <hr class="widget-divider" />
  }

  <div class="filter-bar">
    <app-seg-profile-summary-filters
      [compact]="true"
      [values]="tempFilterValues"
      [availableAgents]="summary?.availableAgents ?? []"
      (filterChange)="onFilterChange($event)"
      >
      <app-widget-org-filter filterAppend
        [orgLevelId]="orgLevelOverrideId"
        (orgLevelIdChange)="onOrgLevelOverrideChange($event)">
      </app-widget-org-filter>
    </app-seg-profile-summary-filters>
  </div>

  <div class="widget-content">
    @if (isLoading) {
      <div class="loading-container">
        <div class="loading-spinner"></div>
      </div>
    }

    @if (error && !isLoading) {
      <div class="error-container">
        <mat-icon>error_outline</mat-icon>
        <span>{{ error | translate }}</span>
      </div>
    }

    @if (!isLoading && !error) {
      @if (summary && summary.currentRiskAssessmentName) {
        <div class="ra-info">
          <span class="ra-name">{{ summary.currentRiskAssessmentName }}</span>
          @if (summary.jurisdictionName) {
            <span class="jurisdiction-name">· {{ summary.jurisdictionName }}</span>
          }
        </div>
      }
      @if ((!summary || !summary.currentRiskAssessmentId) && !displayRows.length) {
        <div class="no-ra-notice">
          <span>{{ 'No current Risk Assessment set for this location' | translate }}</span>
          <a class="ra-list-link" [routerLink]="riskAssessmentsRoute">{{ 'Risk Assessments' | translate }}</a>
        </div>
      }
      @if (displayRows.length) {
        <div class="table-wrapper">
          <table class="seg-table">
            <thead>
              <tr>
                @for (header of tableHeaders; track trackByIndex($index)) {
                  <th (click)="sortBy(header.key)" class="sortable">
                    {{ header.label | translate }}
                    @if (sort.column === header.key) {
                      <mat-icon>{{ sort.ascending ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
                    }
                  </th>
                }
              </tr>
            </thead>
            <tbody>
              @for (row of displayRows; track trackBySegAgent($index, row)) {
                <tr
                  class="data-row"
                  [class.selected]="selectedRow?.segId === row.segId && selectedRow?.agentId === row.agentId"
                  (click)="selectRow(row)"
                  >
                  <td class="seg-name">{{ row.segName }}</td>
                  <td class="agent-name">{{ row.agentName }}</td>
                  <td>
                    <span class="type-pill"
                      [class.type-quant]="row.isQuantitative"
                    [class.type-qual]="row.isQualitative">{{ row.typeLabel }}</span>
                  </td>
                  <td>
                    <span class="band-chip"
                      [class.band-chip-na]="!row.assessedBandColor"
                      [matTooltip]="row.assessedBandRange"
                      matTooltipPosition="above">
                      <span class="band-dot" [style.background-color]="row.assessedBandColor || null"></span>
                      {{ row.assessedBandName || ('N/A' | translate) }}
                    </span>
                  </td>
                  <td>
                    <span class="band-chip"
                      [class.band-chip-na]="!row.currentBandColor"
                      [matTooltip]="row.currentBandRange"
                      matTooltipPosition="above">
                      <span class="band-dot" [style.background-color]="row.currentBandColor || null"></span>
                      {{ row.currentBandName || ('N/A' | translate) }}
                    </span>
                  </td>
                  <td>
                    @if (row.oelNotSet) {
                      <span class="oel-not-set">{{ 'OEL Not Set' | translate }}</span>
                    }
                    @if (!row.oelNotSet && row.decisionStatisticPercentOfOel != null) {
                      <span class="ds-value">
                        {{ row.decisionStatisticPercentOfOel | number:'1.0-2' }}%
                        <mat-icon class="trend-icon" [ngClass]="row.trendClass">{{ row.trendIcon }}</mat-icon>
                      </span>
                    }
                    @if (!row.oelNotSet && row.decisionStatisticPercentOfOel == null) {
                      <span>–</span>
                    }
                  </td>
                  <td class="number-cell">
                    @if (row.isQualitative) {
                      <span>{{ 'N/A' | translate }}</span>
                    }
                    @if (!row.isQualitative) {
                      <span>{{ row.liveSampleCount }}</span>
                    }
                  </td>
                  <td class="number-cell">
                    @if (row.plannedNumberOfSamples != null) {
                      <span>{{ row.plannedNumberOfSamples }}</span>
                    }
                    @if (row.plannedNumberOfSamples == null) {
                      <span class="not-planned-badge">—</span>
                    }
                  </td>
                  <td>
                    @if (row.isQualitative) {
                      <span>{{ 'N/A' | translate }}</span>
                    }
                    @if (!row.isQualitative) {
                      <span class="coverage-badge"
                      [ngClass]="'coverage-badge--' + row.coverageBadge.state">{{ row.coverageBadge.label }}</span>
                    }
                  </td>
                  <td class="number-cell">
                    @if (row.isQualitative) {
                      <span>{{ 'N/A' | translate }}</span>
                    }
                    @if (!row.isQualitative && row.geoStdDev != null) {
                      <span>{{ row.geoStdDev | number:'1.0-2' }}</span>
                    }
                    @if (!row.isQualitative && row.geoStdDev == null) {
                      <span>–</span>
                    }
                  </td>
                  <td>
                    @if (row.isQualitative) {
                      <span>{{ 'N/A' | translate }}</span>
                    }
                    @if (!row.isQualitative) {
                      <span>{{ row.distributionLabel }}</span>
                    }
                  </td>
                  <td class="number-cell">
                    @if (row.isQualitative) {
                      <span>{{ 'N/A' | translate }}</span>
                    }
                    @if (!row.isQualitative && row.convertedDsvDisplay) {
                      <span>{{ row.convertedDsvDisplay }}</span>
                    }
                    @if (!row.isQualitative && !row.convertedDsvDisplay) {
                      <span>–</span>
                    }
                  </td>
                  <td class="number-cell">{{ row.numberOfWorkers ?? '–' }}</td>
                  <td class="number-cell">{{ row.numberOfContractors ?? '–' }}</td>
                </tr>
                @if (selectedRow?.segId === row.segId && selectedRow?.agentId === row.agentId) {
                  <tr class="detail-row">
                    <td colspan="14">
                      <div class="detail-card">
                        <div class="detail-grid">
                          <div class="detail-item">
                            <span class="detail-label">{{ 'SEG' | translate }}</span>
                            <span class="detail-value">{{ row.segName }}</span>
                          </div>
                          <div class="detail-item">
                            <span class="detail-label">{{ 'Agent' | translate }}</span>
                            <span class="detail-value">{{ row.agentName }}</span>
                          </div>
                          <div class="detail-item">
                            <span class="detail-label">{{ 'Assessed Band' | translate }}</span>
                            <span class="detail-value">
                              <span class="band-chip"
                                [class.band-chip-na]="!row.assessedBandColor">
                                <span class="band-dot" [style.background-color]="row.assessedBandColor || null"></span>
                                {{ row.assessedBandName || ('N/A' | translate) }}
                              </span>
                              @if (row.assessedBandRange) {
                                <span class="band-range">{{ row.assessedBandRange }}</span>
                              }
                            </span>
                          </div>
                          <div class="detail-item">
                            <span class="detail-label">{{ 'Current Band' | translate }}</span>
                            <span class="detail-value">
                              <span class="band-chip"
                                [class.band-chip-na]="!row.currentBandColor">
                                <span class="band-dot" [style.background-color]="row.currentBandColor || null"></span>
                                {{ row.currentBandName || ('N/A' | translate) }}
                              </span>
                              @if (row.currentBandRange) {
                                <span class="band-range">{{ row.currentBandRange }}</span>
                              }
                            </span>
                          </div>
                          <div class="detail-item">
                            <span class="detail-label">{{ 'Decision Statistic' | translate }}</span>
                            @if (!row.oelNotSet && row.decisionStatisticPercentOfOel != null) {
                              <span class="detail-value">
                                {{ row.decisionStatisticPercentOfOel | number:'1.0-2' }}% {{ 'OEL' | translate }}
                              </span>
                            }
                            @if (row.oelNotSet) {
                              <span class="detail-value">{{ 'OEL Not Set' | translate }}</span>
                            }
                            @if (!row.oelNotSet && row.decisionStatisticPercentOfOel == null) {
                              <span class="detail-value">–</span>
                            }
                          </div>
                          <div class="detail-item">
                            <span class="detail-label">{{ 'Live Samples' | translate }}</span>
                            <span class="detail-value">{{ row.liveSampleCount }}</span>
                          </div>
                          @if (row.numberOfWorkers != null) {
                            <div class="detail-item">
                              <span class="detail-label">{{ 'Employees' | translate }}</span>
                              <span class="detail-value">{{ row.numberOfWorkers }}</span>
                            </div>
                          }
                          @if (row.numberOfContractors != null) {
                            <div class="detail-item">
                              <span class="detail-label">{{ 'Contractors' | translate }}</span>
                              <span class="detail-value">{{ row.numberOfContractors }}</span>
                            </div>
                          }
                        </div>
                      </div>
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
        </div>
      }
      @if (groupPlanRows.length) {
        <div class="group-plans-section">
          <h5 class="group-plans-title">{{ 'Group Plans' | translate }}</h5>
          <div class="table-wrapper">
            <table class="seg-table group-plan-table">
              <thead>
                <tr>
                  <th>{{ 'SEG' | translate }}</th>
                  <th>{{ 'Agent Group' | translate }}</th>
                  <th>{{ 'Planned (Annual)' | translate }}</th>
                  <th>{{ 'Actual (YTD)' | translate }}</th>
                  <th>{{ 'Coverage' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                @for (plan of groupPlanRows; track trackByGroupPlan($index, plan)) {
                  <tr class="data-row">
                    <td class="seg-name">{{ plan.segName }}</td>
                    <td class="agent-name">{{ plan.agentGroupName }}</td>
                    <td class="number-cell">{{ plan.plannedNumberOfSamples }}</td>
                    <td class="number-cell">{{ plan.actualCount }}</td>
                    <td>
                      <span class="coverage-badge"
                      [ngClass]="'coverage-badge--' + plan.coverageBadge.state">{{ plan.coverageBadge.label }}</span>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }
      @if (summary && summary.currentRiskAssessmentId && !displayRows.length) {
        <div class="empty-state">
          {{ 'No SEG data available for this Risk Assessment' | translate }}
        </div>
      }
      <div class="widget-footer">
        <a *objectHasPermission="segSamplingPlanPermission"
        class="manage-link" [routerLink]="samplingPlansRoute">{{ 'Manage Sampling Plans' | translate }} →</a>
      </div>
    }
  </div>
</div>
